  <template >
<div>
 <div  class="formPosition"    >
     <template>
  <v-row no-gutters>

    <!--DIALOGO PARA A SELEÇÃO DO PERIODO TRIBUTÁRIO-->
            <v-dialog
            v-model="dialog"
            persistent
            max-width="490"
          >
            <v-card>
           <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
              <v-card-title class="headline">
                Escolher o Periodo Tributário
              </v-card-title>
              <v-card-text>
                <v-row>
                   <v-col md="12">
                      <template>

                    <v-menu
                      ref="menubi"
                      v-model="menubi"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field

                          v-model="intervaloDe"
                          :rules="[v => !!v || 'Campo obrigatorio!']"
                          label="intervalo de:"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        max="2050-12-31"
                        min="1950-01-01"
                        v-model="datebi"
                        @change="saveDatebi"
                      ></v-date-picker>
                    </v-menu>
                    </template>
                   </v-col>
                   <v-col md="12">
                      <template>

                    <v-menu
                      ref="menuAte"
                      v-model="menuAte"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field

                          v-model="intervaloAte"
                          :rules="[v => !!v || 'Campo obrigatorio!']"
                          label="Até:"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        max="2050-12-31"
                        min="1950-01-01"
                        v-model="dateAte"
                        @change="saveDateAte"
                      ></v-date-picker>
                    </v-menu>
                    </template>
                   </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="Fechar()"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  :disabled="!valid"
                  @click="SelecionarIntervaloDatas()"
                >
                  Selecionar
                </v-btn>
              </v-card-actions>
           </v-form>
            </v-card>

          </v-dialog>
    <!---->

  <v-col >
     <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container class="grey lighten-5">
      <v-row>
        <v-col md="6">
          <v-chip style="font-size:20px;color:white;" color="#006699">MENU SAFT</v-chip>
          <v-alert
              v-model="alert"
              dismissible
              :type="alertType"
              border="left"
            :icon="iconAlert"
            transition="scale-transition"
            :style="colorAlert"
              elevation="2"
            colored-border
            >
            {{msgAlert}}
          </v-alert>
          <v-spacer></v-spacer>
        </v-col>
      </v-row>
      <v-divider style="background-color:#cccccc;"></v-divider>
        <v-row>
            <v-divider style="background-color:#cccccc;" vertical></v-divider>
              <v-col md="4">
                <v-card>
                      <v-row class="no-gutters">
                          <div class="col-auto">
                              <div class="blue fill-height">&nbsp;</div>
                          </div>
                          <div @click="ImportarSaft()" class="col pa-3 py-4 cyan--text hover">
                             <v-row>
                               <v-col md="12">
                                  <v-icon size="90" class="box2 icone2">import_export</v-icon>
                               </v-col>
                               <v-col md="12"></v-col>
                             </v-row>
                              <h5 class="text-truncate text-uppercase box2">Baixar Ficheiro SAFT-AO</h5>
                           </div>
                      </v-row>
                  </v-card>
              </v-col>
              <v-col md="4">
                <v-card>
                      <v-row class="no-gutters">
                          <div class="col-auto">
                              <div class="blue fill-height">&nbsp;</div>
                          </div>
                          <div class="col pa-3 py-4 primary--text hover">
                            <v-row>
                              <v-col md="12">
                                <v-icon size="90" class="box2 icone2" >cloud_upload</v-icon>
                              </v-col>
                              <v-col md="12">
                                  <h5 class="text-truncate text-uppercase box2">Submissão do ficheiro SAFT-AO</h5>
                              </v-col>
                            </v-row>
                           </div>
                      </v-row>
                  </v-card>
              </v-col>
               <v-col md="3">
                <v-card>
                    <v-row class="no-gutters" style="margin:10px;">
                        <v-col md="12">
                          <span>Periodo Tributário</span>
                        </v-col>
                        <v-col md="6">
                          <span>De:</span>
                        </v-col>
                        <v-col md="6">
                          <span style="font-size:18px;font-weight:bold;">{{intervaloDe}}</span>
                        </v-col>
                        <v-col md="6">
                          <span>Até:</span>
                        </v-col>
                        <v-col md="6">
                          <span style="font-size:18px;font-weight:bold;">{{intervaloAte}}</span>
                        </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="2"></v-col>
                      <v-col md="8">
                         <v-btn color="primary" @click="dialog = true"><v-icon></v-icon>Selecione a data</v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
              </v-col>
          </v-row>
      </v-container>
    </v-col>
  </v-row>
  </template>
   </div>
</div>
</template>

<script>
import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
const FileDownload = require('js-file-download')
const fileUtil = require('fs')
const ls = require('local-storage')
// const message = require('../config/messages')
export default {
  data: () => ({
    msgAlert: 'Ficheiro SAFT-AO Gerado com sucesso',
    alert: false,
    colorAlert: 'red',
    menubi: false,
    menuAte: false,
    dialog: false,
    valid: true,
    intervaloDe: null,
    intervaloAte: null,
    iconAlert: 'done',
    alertType: 'success',
    resultado: null,
    timestamp: '',
    quantidadeVendas: [],
    quantidadeMes: [],
    quantidadeEntradaStock: [],
    anoActual: utilitarios.ObterANOActual(),
    utilitarios: utilitarios,
    overlay: false
  }),

  computed: {

    myStyles () {
      return { height: '99px' }
    },

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    roleUsuario () {
      return ls.get('role')
    },
    role () {
      let rl = ''
      if (ls.get('role') === 'ROLE_GERENTE') {
        rl = 'logado como Gerente'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Sub-Director Pedagógico'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }

  },

  watch: {
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menuAte (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    }
  },

  loggedUserName () {
    return ls.get('nomeUsuario')
  },
  created () {
    // console.log(ls.get('uuid'));

    this.timestamp = new Date()
    this.dialog = true
  },

  methods: {

    async    GetUserLocation () {
      return this.$getLocation()
        .then(coordinates => {
          return 'coordinates'
        })
    },

    Call () {
      console.log('============' + Object.values(this.GetUserLocation))
    },

    getNow () {
      const today = new Date()
      const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()
      const dateTime = date + ' ' + time
      this.timestamp = date
    },

    async Dados () {
      await axios({
        url: 'http://localhost:8085/readfile/SAFT-AO.xml',
        method: 'GET',
        responseType: 'blob' // Important
      }).then(function (response) {
        FileDownload(response.data, 'SAFT-AO.xml')
      })
    },


     async WriteSaftToFile (result) {
     return  await axios({
        url: 'http://localhost:8085/writesaft',
        method: 'post',
        data: result,
        responseType:'stream',
      }).then(res=>res.data)
    },


    async  ImportarSaft () {

      if(this.intervaloDe === null || this.intervaloAte === null)
        this.dialog = true
      else{
          this.overlay = true
          try {
            let params = {
              data1: this.intervaloDe,
              data2: this.intervaloAte
            }
            let result = await axios
              .post('/CriarSaftAGT', params)
              .then(res => res.data)
            this.overlay = false
            if (result) {
              this.alert = true
              this.colorAlert = 'color:green;'
              this.iconAlert = 'done'
              this.alertType = 'success'
              this.Dados()
              setTimeout(() => {
                this.alert = false
              }, 2000)
            } else {
              this.alert = true
              this.colorAlert = 'color:red;'
              this.iconAlert = 'error'
              this.alertType = 'error'
              this.msgAlert = 'Ocorreu um erro ao tentar gerar o ficheiro SAFT-AO'
              setTimeout(() => {
                this.alert = false
              }, 2000)
            }
          } catch (error) {
            this.overlay = false
            this.text = error
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
          }finally{
            this.overlay = false
          }
      }
    },
    saveDatebi (datebi) {
      this.$refs.menubi.save(datebi)
      this.intervaloDe = datebi

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
    },
    saveDateAte (dateAte) {
      this.$refs.menuAte.save(dateAte)
      this.intervaloAte = dateAte

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
    },
    SelecionarIntervaloDatas () {
      if (this.$refs.form.validate()) {
        this.dialog = false
      }
    },
    Fechar () {
       this.dialog = false 
    }

  }
}
</script>
<style scoped\>
  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
  .box2{
    margin-left:90px;
  }
   .icone2{
    margin-left:130px;
  }
  .hover:hover{
    background-color: #e5ebe1;
  }
</style>
